exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__crypto-card-title-line___3HmJB{display:flex;flex-flow:row;justify-content:space-between;align-items:center;margin-bottom:.5rem;font-size:20px;color:#fff}", ""]);

// exports
exports.locals = {
	"crypto-card-title-line": "styles__crypto-card-title-line___3HmJB"
};